import React from 'react'
import PropTypes from 'prop-types'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { uploadConfig } from 'utils'

import styles from './MultipleChoice.module.scss'

class MultipleChoice extends React.Component {
  state = {
    options: [
      {
        id: new Date().getTime(),
        text: '',
      },
    ],
  }

  onChange = index => event => {
    const option = this.state.options.slice()

    option[index][event.target.name] =
      event.target.name === 'correct' ? event.target.checked : event.target.value

    this.setState({ options: option }, () => this.props.callback(this.state.options))
  }

  onChangeCkEditor = (index, editor) => {
    const option = this.state.options.slice()
    option[index].text = editor.getData()
    this.setState({ options: option }, () => this.props.callback(this.state.options))
  }

  onRadioChange = (selectedIndex, event) => {
    const newOptions = this.state.options.map((item, index) => {
      if (event.target.type === 'radio') {
        return selectedIndex === index
          ? { ...item, correct: event.target.checked }
          : { ...item, correct: false }
      }
      return item
    })
    this.setState({ options: newOptions }, () => this.props.callback(this.state.options))
  }

  addMoreOption = () => {
    const newOption = [...this.state.options, { id: new Date().getTime(), text: '' }]
    this.setState({ options: newOption }, () => this.props.callback(this.state.options))
  }

  removeOption = event => {
    const array = [...this.state.options]
    array.splice(event.target.value, 1)
    this.setState({ options: array }, () => this.props.callback(this.state.options))
  }
  render() {
    return (
      <div className={styles['multiple-choice']}>
        {this.state.options.map((option, index) => (
          <div key={option.id}>
            <div>
              {this.props.type === 'multiple_choice' && (
                <>
                  <input
                    className={styles['input-checkbox']}
                    type='checkbox'
                    value={option.correct}
                    name='correct'
                    onChange={this.onChange(index)}
                  />
                  <label>Alternativa correta</label>
                </>
              )}
              {this.props.type === 'objective' && (
                <>
                  <input
                    className={styles['input-radio']}
                    type='radio'
                    value={option.correct}
                    name='correct'
                    onChange={event => this.onRadioChange(index, event)}
                  />
                  <label>Alternativa correta</label>
                </>
              )}
            </div>
            <div className={styles.ckeditor}>
              <CKEditor
                editor={window.ClassicEditor}
                config={uploadConfig}
                onChange={(_, editor) => this.onChangeCkEditor(index, editor)}
              />
            </div>

            {this.state.options.length > 1 && (
              <div className={styles['div-button']}>
                <button
                  className={`${styles['display-grid']} ${styles['button-delete']}`}
                  type='button'
                  value={index}
                  onClick={this.removeOption}
                >
                  Remover
                </button>
              </div>
            )}
          </div>
        ))}

        <button type='button' className={styles['button-add']} onClick={this.addMoreOption}>
          + item
        </button>
      </div>
    )
  }
}
MultipleChoice.propTypes = {
  callback: PropTypes.func,
  type: PropTypes.string,
}
export default MultipleChoice
